{
  "version": 1,
  "asset_id": "50282b76-cf1a-423c-a710-e5e58d20ec0e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/50282b76-cf1a-423c-a710-e5e58d20ec0e/crystal-river-blue-shingle-roof-destination-roofing-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/50282b76-cf1a-423c-a710-e5e58d20ec0e/crystal-river-blue-shingle-roof-destination-roofing-480w.avif",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-480w.avif",
  "size": 11473,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
